import { useRef, useState, useEffect } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { useToast } from '../common/toast/hooks/useToast'
import axios from '../../api/axios'
import useAuth from '../../hooks/useAuth'
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const ForgotPassword = () => {
    const navigate = useNavigate()
    const { setAuth }: any = useAuth()

    const emailRef = useRef()
    const errRef = useRef()

    const { triggerToast } = useToast()

    const [email, setEmail] = useState('')
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false)
    const [errMsg, setErrMsg] = useState('')

    useEffect(() => {
        setErrMsg('')
    }, [email])

    const handleSubmit = async (e) => {
        e.preventDefault()
        setIsSubmitting(true)

        try {
            const response = await axios
                .post(
                    '/auth/reset-password',
                    {
                        email,
                    },
                    {
                        headers: { 'Content-Type': 'application/json' },
                        withCredentials: true,
                    }
                )
                .catch((err) => {
                    return err
                })
                .finally(() => {
                    setIsSubmitting(false)
                })

            if (response.data?.success === true) {
                triggerToast({
                    severity: 'success',
                    summary: 'Successful',
                    detail: "We've sent you an email with your password reset link. Please don't forget to check your spam folder!",
                })
                setAuth({})
                navigate('/login')
            }

            if (!response.response.data.success) {
                throw Error(response.response.data.errors.join('<br />'))
            }
        } catch (err) {
            if (err?.message) {
                setErrMsg(err.message)
            } else if (!err?.response) {
                setErrMsg('No Server Response')
            } else if (err.response?.status === 404) {
                setErrMsg('Record was not found')
            } else if (err.response?.data?.success === false) {
                setErrMsg(err.response?.data?.errors.join('<br />'))
            } else {
                setErrMsg('Failed to update password')
            }
        }
    }

    return (
        <section className="bg-gradient-primary vh-100">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-xl-10 col-lg-12 col-md-9">
                        <div className="card o-hidden border-0 shadow-lg my-5">
                            <div className="card-body p-0">
                                <div className="row">
                                    <div className="col-lg-6 d-none d-lg-block bg-login-image" />
                                    <div className="col-lg-6">
                                        <div className="p-5">
                                            <div className="text-center">
                                                <h1 className="h4 mb-4">
                                                    Reset your password
                                                </h1>
                                                <p
                                                    ref={errRef}
                                                    className={
                                                        'text-danger small ' +
                                                        (errMsg
                                                            ? 'errmsg'
                                                            : 'offscreen')
                                                    }
                                                    aria-live="assertive"
                                                >
                                                    {errMsg && (
                                                        <>
                                                            <FontAwesomeIcon
                                                                icon={
                                                                    faExclamationTriangle
                                                                }
                                                            />{' '}
                                                            {errMsg}
                                                        </>
                                                    )}
                                                </p>
                                            </div>
                                            <form
                                                className="user"
                                                onSubmit={handleSubmit}
                                            >
                                                <div className="form-group mb-3">
                                                    <input
                                                        type="email"
                                                        ref={emailRef}
                                                        className="form-control form-control-user p-3"
                                                        id="email"
                                                        aria-describedby="emailHelp"
                                                        placeholder="Enter your email..."
                                                        onChange={(e) =>
                                                            setEmail(
                                                                e.target.value
                                                            )
                                                        }
                                                        value={email}
                                                        required
                                                    />
                                                </div>
                                                <div className="text-center d-grid gap-2">
                                                    <button
                                                        className="btn btn-primary btn-user d-block"
                                                        disabled={isSubmitting}
                                                    >
                                                        {isSubmitting
                                                            ? 'Sending email...'
                                                            : 'Request Password Reset'}
                                                    </button>
                                                </div>
                                            </form>
                                            <hr />
                                            <div className="text-center">
                                                <Link
                                                    to={'/login'}
                                                    className="small"
                                                >
                                                    Cancel
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ForgotPassword
